import { View } from './view'

export const Materials = View
